import { Box, SxProps, Typography } from '@mui/material';
import React from 'react';
import { Campaign, Channels, Conversation } from 'generated-graphql/types';
import { Button } from 'system/atoms';
import { useDrawer } from 'services/drawer/hooks';
import { useBottomDrawer } from 'core/stores/bottomDrawer/hooks';
import { DrawerComponentType } from 'services/drawer/types';
import { useOrganization } from 'core/stores/hooks/useOrganization';
import { useNavigate } from 'react-router-dom';
import { Paths } from 'services/navigation/paths';
import { useTracking } from 'services/tracking/hooks';
import { TrackingEventName } from 'services/tracking/constants';

const container: SxProps = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: 2
};

const buttonsContainer: SxProps = {
  display: 'flex',
  flexDirection: 'row',
  gap: 1
};

type Props = {
  conversations: Conversation[];
  campaign: Campaign;
  onComplete: () => void;
};

export const UpdateConversationsBottomDrawer: React.FC<Props> = ({
  conversations,
  campaign,
  onComplete
}) => {
  const { closeBottomDrawer } = useBottomDrawer();
  const navigate = useNavigate();
  const { openDrawer } = useDrawer();
  const organization = useOrganization();
  const isSmsEnabled = organization.channelsEnabled?.includes(Channels.Sms);
  const isCampaignHumanOutreachEnabled = true;
  const { track } = useTracking();

  const handleChangeStage = () => {
    openDrawer({
      drawerContentType: DrawerComponentType.UpdateApplicationStage,
      drawerComponentProps: {
        conversations,
        hideCloseIconButton: true,
        onComplete
      }
    });
  };

  return (
    <Box sx={container}>
      <Typography>{conversations.length} candidate(s) selected</Typography>
      <Box sx={buttonsContainer}>
        <Button variant="primary" onClick={handleChangeStage}>
          Change stage
        </Button>
        {isCampaignHumanOutreachEnabled && (
          <>
            {isSmsEnabled && (
              <Button
                variant="primary"
                onClick={() => {
                  navigate(Paths.CAMPAIGN_CREATE_WITH_PARTICIPANTS, {
                    state: {
                      conversations,
                      campaign
                    }
                  });
                }}
              >
                Send message in new campaign
              </Button>
            )}
            <Button
              variant="primary"
              onClick={() => {
                navigate(
                  Paths.CAMPAIGN_CREATE_WITH_PARTICIPANTS_SELECT_CAMPAIGN,
                  {
                    state: {
                      conversations,
                      campaign
                    }
                  }
                );

                track(TrackingEventName.AddToExistingCampaign, {
                  conversationsCount: conversations.length
                });
              }}
            >
              Add to existing campaign
            </Button>
          </>
        )}
        <Button onClick={closeBottomDrawer}>Cancel</Button>
      </Box>
    </Box>
  );
};
